import React from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { FilterBar } from './filterBar';
import { ReportAccordionWithPreview } from './reportAccordionWithPreview';
import { ReportContent } from './reportContent';
import { ReportHeading } from './reportHeading';
import { useFilters } from '../../hooks/useFilters';
import { FilterValues, ReportFilter } from '../../types/filters';
import { ReportGridGroup, ReportGridItem } from '../../types/report';

export const Report = ({
  controls,
  description,
  filters = [],
  groups,
  items,
  onFiltersChange,
  tipMarkdown,
  title,
}: {
  controls?: React.ReactNode;
  description: string;
  filters?: ReportFilter[];
  groups?: ReportGridGroup[];
  items?: ReportGridItem[];
  onFiltersChange?: (filterValues: FilterValues) => void;
  tipMarkdown?: string;
  title: string;
}) => {
  const { clearFilters, filterValues, groupsWithFilters, handleFilterChange, itemsWithFilters } =
    useFilters({
      filters,
      groups,
      items,
      onFiltersChange,
    });

  return (
    <Stack direction="column" spacing={2}>
      <Stack alignItems="flex-start" direction="row" justifyContent="space-between">
        <Box sx={{ flexShrink: 0 }}>{controls}</Box>
        <FilterBar
          filters={filters}
          filterValues={filterValues}
          handleFilterChange={handleFilterChange}
        />
      </Stack>
      <ReportHeading description={description} tipMarkdown={tipMarkdown} title={title} />
      {itemsWithFilters && <ReportContent clearFilters={clearFilters} items={itemsWithFilters} />}
      {groupsWithFilters?.map((group) => (
        <ReportAccordionWithPreview key={group.title} clearFilters={clearFilters} group={group} />
      ))}
    </Stack>
  );
};
